import React, { useLayoutEffect } from 'react';
import { View, StyleSheet } from 'react-native';
import { useSelector, useDispatch } from 'react-redux';
import ProfileForm from '../me/ProfileForm';
import { selectUserProfile } from '../../store/selectors/profile.selector';
import { Screens } from '../../constants/ScreenNames';
import { updateProfileData } from '../../store/actions/profile';

const ProfileModal = ({ navigation, route }) => {
  const userProfile = useSelector(selectUserProfile);
  const {
    countryList,
    approvalList,
    groupDetails,
    notificationList,
    userRoleDetails,
    isUpdateAllowed,
  } = route.params;
  const dispatch = useDispatch();

  const onSubmit = (data) => {
    (async () => {
      await dispatch(updateProfileData(data));
      navigation.navigate(Screens.Me);
    })();
  };

  useLayoutEffect(() => {
    if (!isUpdateAllowed) {
      navigation.setOptions({
        title: 'View Profile',
      });
    }
  }, [navigation, isUpdateAllowed]);

  return (
    <View style={styles.body}>
      <ProfileForm
        profile={userProfile}
        countryList={countryList}
        approvalList={approvalList}
        groupDetails={groupDetails}
        notificationList={notificationList}
        userRoleDetails={userRoleDetails}
        onSubmit={onSubmit}
        isUpdateAllowed={isUpdateAllowed}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  body: {
    flex: 1,
    backgroundColor: 'white',
  },
});

export default ProfileModal;
